module.exports = __webpack_public_path__ + "img/stone2.edd8791e.png";